module.exports = __webpack_public_path__ + "static/media/user.a87c3f70.svg";